import React from 'react';
import styles from './Flag.module.scss';
import cn from 'classnames';

const Flag = ({country, className}) => {
    return <div className={cn(styles.flag, className, styles[country.toLowerCase()])} />;
};

export default Flag;
